<template>

    <!-- PAGO EN PROGRESO -->
    <div class="container " id="app">
    <div class="bg-page"></div>
    <div class="row justify-content-md-center">
        <div class="col-12 col-lg-8 p-0">
            <main>
                <!-- INICIA PAGO CON ERROR -->
                <div class="title-center">
                    <h1>
                        <span class="icons-clock text-info"></span>
                        {{ __('messages.processing_payment_reservation') }} {{data.customerName || data.email.split("@")[0]}}...
                    </h1>
                </div>
                <!-- ACABA PAGO CON ERROR -->
                <div class="card shadow-300">
                    <div class="card-info-collumns pt-3">
                        <div class="">
                            <span class="font-18 font-600">{{ __('messages.thankSite', [siteConfig.appName]) }}</span>
                            <p class="pt-4 font-16">{{ __('messages.thank_you_choosingrapd') }}</p>
                            <p class="pt-4 font-16">{{ __('messages.thank_you_choosing_processing',[data.email]) }} {{ __('messages.thank_you_choosing_processing_2') }} <a class="btn-link" :href="'tel:' + siteConfig.phonePrimary">{{ siteConfig.phoneFormat }}</a>{{ __('messages.thank_you_choosing_processing_3') }}</p>
                            <h3 class="pt-4 font-18 font-600 pb-0 mb-0">{{ __('messages.no_locator') }} {{ data.id }}</h3>
                            <p class="pt-2  font-16">{{ __('messages.use_number_locator') }}</p>
                        </div>
                    </div>
                    <div class="col-md-12 text-center" v-if="retry" style="    position: absolute;
    z-index: 99999;
    height: 100%;
    width: 100%;
    align-content: center;
    background: white;
    backdrop-filter: blur(1px);">
                        <p class="mt-2 font-weight-bold"> {{__("messages.please_wait_voucher")}} </p>
                        <div class="d-flex justify-content-center loader-retry"> <div class="loader__circle"></div> </div>
                    </div>
                    <!-- <button type="submit" class="btn btn-primary btn-lg btn-middle but">Check itinerary</button> -->
                </div>
       

            </main>
            <!-- <div class="card my-5" role="complementary" aria-label="complementary products">
                <div class="title-card pb-0">
                    <h2>{{data.customerName}}!, {{ __('messages.need_anything_else') }}</h2>
                </div>
                <div class="card-info-collumns">
                    <div class="two-collumns">
                        <h3><span class="icons-plane icons-title" aria-hidden="true"></span> {{ __('messages.reserve_flight') }}</h3>
                        <p>{{ __('messages.buy_thousands_flights') }}</p>
                        <a class="btn btn-secondary btn-lg but" :href="__('url.url_packages')" target="_blank">{{ __('messages.view_more') }}</a>
                    </div>
                    <div class="two-collumns border-top-mobile">
                        <h3><span class="icons-flame1 icons-title" aria-hidden="true"></span> {{ __('messages.special_deals') }}</h3>
                        <p>{{ __('messages.find_best_deals') }}</p>
                        <a class="btn btn-secondary btn-lg but" :href="__('url.url_tours')" target="_blank">{{ __('messages.view_more') }}</a>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>



</template>

<script>
import { AlgoliaServices } from '../../services/AlgoliaService';

const site = window.__pt.settings.site;

export default {
    props: ['data', 'retry', 'rapd'],
    data() {
        return {
            type: {},
            siteConfig: site
        };
    },
    async mounted() {
        this.getEventAlgolia();
    },
    methods: {
        getEventAlgolia() {
            AlgoliaServices.getEventAlgolia("Order", "purchase");
        }
    },
    components: {
    }
}
</script>
